import { render } from "./CIDStaffWorkloadDialog.vue?vue&type=template&id=3f1175f6&scoped=true"
import script from "./CIDStaffWorkloadDialog.vue?vue&type=script&lang=js"
export * from "./CIDStaffWorkloadDialog.vue?vue&type=script&lang=js"

import "./CIDStaffWorkloadDialog.vue?vue&type=style&index=0&id=3f1175f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1175f6"]])

export default __exports__